import React, { useEffect, useState } from 'react';
import qs from 'qs';
import { Table, Space } from 'antd';
import { http } from '../../utils';
import './index.scss'

const getRandomuserParams = (params) => ({
  pagesize: params.pagination?.pagesize,
  current: params.pagination?.current,
  startTime: params?.startTime,
  endTime: params?.endTime
});

const columns = [
  {
    title: 'username',
    dataIndex: 'username',
  },
  {
    title: 'Email',
    dataIndex: 'userEmail',
  },
  {
    title: 'Role',
    dataIndex: 'role',
    render: (status) => {
      return (
        <Space>
          { status === '0' ? ' Manage': 'User' }
        </Space>
      )
    }
  },
  {
    title: 'Status',
    dataIndex: 'status',
    render: (status) => {
      return (
        <Space>
          { status === '0' ? ' Normal': 'Freeze' }
        </Space>
      )
    }
  }
];


const Account = () => {
  const [ data, setData ] = useState();
  const [ loading, setLoading ] = useState(false);
  const [ total, setTotal ] = useState(0);
  const [ tableParams, setTableParams ] = useState({
    startTime: '',
    endTime: '',
    pagination: {
      current: 1,
      pagesize: 10
    }
  });
  
  useEffect(() => {
    let cancelled = false;
    const loadData = async () => {
      setLoading(true);
      const res = await http.get(`/api/user/list?${qs.stringify(getRandomuserParams(tableParams))}`);
      if (!cancelled && res?.results) {
        setData(res.results);
        setTotal(res.total);
        setLoading(false);
      }
    };
    loadData();
    return () => { cancelled = true; };
  }, [tableParams]);
  
  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });

    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };
  
  return (
    <div>
      <div className="account-header">Account</div>
      <div className="account-content">
        <Table
          columns={columns}
          rowKey={(record) => record.id}
          dataSource={ data }
          pagination={{ ...tableParams.pagination, total }}
          loading={loading}
          onChange={ handleTableChange }
        >
        </Table>
      </div>
    </div>
  )
}

export default Account;